import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-701cadf7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "related-orders-popup"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "关联订单", -1));
const _hoisted_5 = {
  class: "order-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "item-left"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "item-right"
};
const _hoisted_10 = {
  class: "product-title"
};
const _hoisted_11 = {
  class: "product-info"
};
const _hoisted_12 = {
  class: "product-price"
};
const _hoisted_13 = {
  key: 0,
  class: "product-count"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: $options.ifShow,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $options.ifShow = $event),
    position: "bottom",
    round: "",
    "close-on-click-overlay": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_van_icon, {
      class: "icon",
      name: "close",
      size: "20",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.closePopup(), ["stop"]))
    })]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.ordersList, (order, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "order-item",
        key: index,
        onClick: $event => $options.goToOrderDetail(order.order_id)
      }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        class: "product-img",
        src: `${_ctx.$imgUrlFilter(order.show_img, 180)}`,
        alt: "商品图片"
      }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(order.reward_title), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(order.show_amount), 1), order.order_num ? (_openBlock(), _createElementBlock("span", _hoisted_13, "×" + _toDisplayString(order.order_num), 1)) : _createCommentVNode("", true)])])], 8, _hoisted_6);
    }), 128))])])]),
    _: 1
  }, 8, ["show"])]);
}